import React, { Component } from 'react';
import Lottie from 'lottie-react';
import './LottiePlayer.css';

export default class LottiePlayer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animationData: null,
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.loadAnimation();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.animatedUrl !== this.props.animatedUrl) {
            this.loadAnimation();
        }
    }

    loadAnimation = async () => {
        const { animatedUrl } = this.props;
        
        if (!animatedUrl) {
            this.setState({ loading: false, error: 'No animation URL provided' });
            return;
        }

        this.setState({ loading: true, error: null });

        try {
            const response = await fetch(animatedUrl);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const animationData = await response.json();
            
            // Validate if it's a Lottie animation
            if (!animationData.v || !animationData.fr || !animationData.layers) {
                throw new Error('Invalid Lottie animation format');
            }
            
            this.setState({ 
                animationData, 
                loading: false, 
                error: null 
            });
        } catch (error) {
            console.error('Error loading Lottie animation:', error);
            this.setState({ 
                loading: false, 
                error: error.message,
                animationData: null 
            });
        }
    };

    render() {
        const { 
            width = '100%', 
            height = '200px', 
            autoPlay = true, 
            loop = true,
            showControls = false,
            giftName = 'Lottie Animation'
        } = this.props;
        
        const { animationData, loading, error } = this.state;

        if (loading) {
            return (
                <div className="lottie-player-container" style={{ width, height }}>
                    <div className="lottie-loading">
                        <div className="loading-spinner"></div>
                        <p>Đang tải animation...</p>
                    </div>
                </div>
            );
        }

        if (error) {
            return (
                <div className="lottie-player-container" style={{ width, height }}>
                    <div className="lottie-error">
                        <i className="fas fa-exclamation-triangle"></i>
                        <p>Lỗi tải animation</p>
                        <small>{error}</small>
                    </div>
                </div>
            );
        }

        if (!animationData) {
            return (
                <div className="lottie-player-container" style={{ width, height }}>
                    <div className="lottie-no-data">
                        <i className="fas fa-file"></i>
                        <p>Không có dữ liệu animation</p>
                    </div>
                </div>
            );
        }

        return (
            <div className="lottie-player-container" style={{ width, height }}>
                <div className="lottie-animation">
                    <Lottie
                        animationData={animationData}
                        loop={loop}
                        autoplay={autoPlay}
                        style={{ 
                            width: '100%', 
                            height: '100%',
                            maxWidth: '100%',
                            maxHeight: '100%'
                        }}
                    />
                </div>
                {showControls && (
                    <div className="lottie-controls">
                        <div className="lottie-info">
                            <span className="gift-name">{giftName}</span>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
